(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const applyAccordionState = function () {
      const footerContainer = document.querySelector('[data-show-accordion]');

      const showAccordionOnMobile =
        footerContainer &&
        footerContainer.getAttribute('data-show-accordion') === 'true';

      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      document.querySelectorAll('details[data-accordion]').forEach(function (el) {
        if (showAccordionOnMobile && isMobile) {
          el.removeAttribute('open');
        } else {
          el.setAttribute('open', '');
        }
      });
    };

    applyAccordionState();

    window.addEventListener('resize', applyAccordionState);

    document.addEventListener('shopify:section:load', function () {
      applyAccordionState();
    });
  });

  /*
   * Stop href="#" from changing the URL to:
   * https://www.jaxxliving.com/#
   *
   * This does not stop UserWay's click handler.
   */
  document.addEventListener('click', function (event) {
    const accessibilityLink = event.target.closest('#accessibilityWidget');

    if (!accessibilityLink) {
      return;
    }

    event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const applyAccordionState = () => {
        const showAccordionOnMobile =
          document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        document.querySelectorAll('details[data-accordion]').forEach((el) => {
          if (showAccordionOnMobile && isMobile) {
            // Show accordion on mobile if setting allows
            el.removeAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','false');
          } else if (!showAccordionOnMobile && isMobile) {
            // Do not show accordion on mobile if setting disallows
           // el.setAttribute('open');
          } else if (!isMobile) {
            // On desktop, always open accordions
            el.setAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','true');
          }
        });
      };
      applyAccordionState();
      window.addEventListener('resize', applyAccordionState);
      document.addEventListener('shopify:section:load', (event) => {
        // Apply accordion state when a new section is loaded
        applyAccordionState();
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
